import useAPIService from '../common/useApiService';

export const useCreateJob = state => {
  const [createJob, invokeCreateJob] = useAPIService(`jobs`, { method: 'post', data: state });

  return [
    createJob,
    invokeCreateJob
  ];
}